import { forwardRef } from "react";
import { Tooltip } from "@mui/material";
import useLanguage from "../../hooks/useLanguage";
import { flagSvgUrl } from "./utils.js";

const NAMES = {};
const countryName = (code, lang) => {
  const loc = lang === "heb" ? "he" : "en";
  const upper = code.toUpperCase();
  try {
    NAMES[loc] =
      NAMES[loc] || new Intl.DisplayNames([loc], { type: "region" });
    return NAMES[loc].of(upper) || upper;
  } catch (_) {
    return upper;
  }
};

// Wraps whatever element should be the hover target — the chip, not just the
// flag inside it.
export function CountryTip({ code, children }) {
  const [{ code: lang }] = useLanguage();
  if (!code) return children;
  return (
    <Tooltip title={countryName(code, lang)} placement="top" arrow>
      {children}
    </Tooltip>
  );
}

// SVG, not the emoji: Windows Chrome renders regional indicators as bare
// letters. alt = the code, so a blocked CDN degrades to "US", not a broken icon.
const Flag = forwardRef(function Flag({ code, w = 18, h = 13, ...rest }, ref) {
  if (!code) return null;
  return (
    <img
      {...rest}
      ref={ref}
      src={flagSvgUrl(code)}
      alt={code.toUpperCase()}
      loading="lazy"
      style={{
        width: w,
        height: h,
        objectFit: "cover",
        borderRadius: 2,
        display: "block",
        boxShadow: "0 0 0 1px rgba(0, 0, 0, 0.06)",
      }}
    />
  );
});

export default Flag;
